<template>
    <div class="df-mega" :class="{ 'is-open': open }" :aria-hidden="(!open).toString()">
        <div ref="panelEl" class="df-mega__panel">
            <div class="df-mega__inner">
                <!-- 车型 -->
                <div v-show="activeKey === 'models'" class="df-mega__section">
                    <div class="df-mega__category-tabs" role="tablist" aria-label="车型分类">
                        <button
                            v-for="category in carCategories"
                            :key="category"
                            type="button"
                            class="df-mega__category-tab"
                            :class="{ 'is-active': category === selectedCarCategory }"
                            :aria-selected="(category === selectedCarCategory).toString()"
                            role="tab"
                            @click="$emit('car-category-select', category)">
                            {{ category }}
                        </button>
                    </div>
                    <div
                        v-for="group in modelGroups"
                        :key="group.title"
                        class="df-mega__group">
                        <h3 class="df-mega__group-title">{{ group.title }}</h3>
                        <div class="df-mega__cars">
                            <a
                                v-for="car in group.items"
                                :key="car.id"
                                href="javascript:;"
                                class="df-mega-car"
                                @click.prevent="$emit('navigate', car.path || '/car')">
                                <div class="df-mega-car__body">
                                    <div class="df-mega-car__meta">
                                        <div class="df-mega-car__name">{{ car.name }}</div>
                                        <div class="df-mega-car__desc">{{ car.desc }}</div>
                                    </div>
                                    <img :src="car.image" :alt="car.name" class="df-mega-car__img">
                                    <div class="df-mega-car__price">
                                        <span v-if="$i18n.locale === 'en'" class="df-mega-car__price-unit">{{ car.priceUnit }}</span>
                                        <span class="df-mega-car__price-num">{{ car.priceNum }}</span>
                                        <span v-if="$i18n.locale !== 'en'" class="df-mega-car__price-unit">{{ car.priceUnit }}</span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 技术 -->
                <div v-show="activeKey === 'technology'" class="df-mega__section">
                    <div
                        v-for="group in techGroups"
                        :key="group.title"
                        class="df-mega__group">
                        <h3 class="df-mega__group-title">{{ group.title }}</h3>
                        <div class="df-mega__cards">
                            <a
                                v-for="item in group.items"
                                :key="item.id"
                                href="javascript:;"
                                class="df-mega-card"
                                @click.prevent="$emit('navigate', item)">
                                <img :src="item.image" :alt="item.name" class="df-mega-card__bg">
                                <span class="df-mega-card__title">{{ item.name }}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 关于我们 -->
                <div v-show="activeKey === 'about'" class="df-mega__section">
                    <div class="df-mega__group">
                        <h3 class="df-mega__group-title">{{ $t('关于我们') }}</h3>
                        <div class="df-mega__cards">
                            <a
                                v-for="item in aboutItems"
                                :key="item.name"
                                href="javascript:;"
                                class="df-mega-card"
                                @click.prevent="$emit('navigate', item.path)">
                                <img :src="item.image" :alt="item.name" class="df-mega-card__bg">
                                <span class="df-mega-card__title">{{ $t(item.name) }}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 其他工具 -->
                <div v-show="activeKey === 'tools'" class="df-mega__section">
                    <div class="df-mega__group">
                        <h3 class="df-mega__group-title">{{ $t('其他工具') }}</h3>
                        <div class="df-mega__cards">
                            <a
                                v-for="item in toolItems"
                                :key="item.name"
                                href="javascript:;"
                                class="df-mega-card"
                                @click.prevent="$emit('navigate', item.path)">
                                <img :src="item.image" :alt="item.name" class="df-mega-card__bg">
                                <span class="df-mega-card__title">{{ $t(item.name) }}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- 个人中心（悬停用户头像展开，样式与技术/工具卡片一致） -->
                <div v-show="activeKey === 'user'" class="df-mega__section">
                    <div class="df-mega__group">
                        <h3 class="df-mega__group-title">{{ $t('个人中心') }}</h3>
                        <div class="df-mega__cards">
                            <a
                                v-for="item in userItems"
                                :key="item.name"
                                href="javascript:;"
                                class="df-mega-card"
                                @click.prevent="onUserItemClick(item)">
                                <img :src="item.image" :alt="item.name" class="df-mega-card__bg">
                                <span class="df-mega-card__title">{{ $t(item.name) }}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { createMotion, resolveEl } from '@/utils/gsap';

    export default {
        name: 'NavMegaPanel',
        props: {
            open: {
                type: Boolean,
                default: false,
            },
            activeKey: {
                type: String,
                default: '',
            },
            modelGroups: {
                type: Array,
                default: () => [],
            },
            carCategories: {
                type: Array,
                default: () => [],
            },
            selectedCarCategory: {
                type: String,
                default: '',
            },
            techGroups: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                // 关于我们菜单沿用站内通用封面图，避免依赖首页接口图片资源。
                aboutItems: [
                    { name: '东风快讯', image: require('../../../static/image/nav/about-news.png'), path: '/about/news' },
                    { name: '关于我们', image: require('../../../static/image/about/mission.png'), path: '/about' },
                    { name: '联系我们', image: require('../../../static/image/nav/contact.png'), path: '/about/contact' },
                ],
                toolItems: [
                    { name: '车型参数对比', image: require('../../../static/image/nav/about-news.png'), path: '/tools/compare' },
                    { name: '金融试算器', image: require('../../../static/image/nav/tool-finance.png'), path: '/tools/finance' },
                ],
                userItems: [
                    { name: '个人信息', image: require('../../../static/image/nav/user-profile.png'), path: '/userCenter' },
                    { name: '我的预定', image: require('../../../static/image/nav/user-orders.png'), path: '/my/bookings' },
                    { name: '我的预约试驾', image: require('../../../static/image/nav/user-testdrive.png'), path: '/my/testdrives' },
                    { name: '退出登录', image: require('../../../static/image/about/mission.png'), action: 'logout' },
                ],
            };
        },
        created() {
            this.motion = createMotion();
            this._animating = false;
            this._animToken = 0;
        },
        mounted() {
            const panel = resolveEl(this.$refs.panelEl);
            if (panel && this.motion) {
                this.motion.set(panel, {
                    height: 0,
                    autoAlpha: 0,
                    overflow: 'hidden',
                });
            }
        },
        beforeDestroy() {
            if (this.motion) {
                this.motion.kill();
                this.motion = null;
            }
        },
        watch: {
            open(val) {
                this.animatePanel(val);
            },
            activeKey(key) {
                if (this.open && key) {
                    this.$nextTick(() => this.refreshOpenHeight());
                }
            },
        },
        methods: {
            animatePanel(open) {
                const motion = this.motion;
                const panel = resolveEl(this.$refs.panelEl);
                if (!motion || !panel) return;

                const token = ++this._animToken;
                this._animating = true;

                // 打断进行中的开合，避免快速切换时被旧动画压住
                if (motion.gsap) {
                    motion.gsap.killTweensOf(panel);
                }

                if (open) {
                    // 等 v-show 内容完成布局后再量高度，修复从「无下拉项」快速切回时高度为 0
                    this.$nextTick(() => {
                        if (token !== this._animToken || !this.open) return;
                        this.openPanel(panel, motion, token);
                    });
                } else {
                    const current = panel.offsetHeight || 0;
                    motion.set(panel, {
                        height: current,
                        overflow: 'hidden',
                        autoAlpha: current > 0 ? 1 : 0,
                    });
                    motion.to(panel, {
                        height: 0,
                        autoAlpha: 0,
                        duration: current > 0 ? 0.28 : 0,
                        ease: 'power2.inOut',
                        overwrite: true,
                        onComplete: () => {
                            if (token !== this._animToken) return;
                            this._animating = false;
                            panel.style.height = '0px';
                        },
                    });
                }
            },
            openPanel(panel, motion, token) {
                // 先以 auto 测量真实内容高度
                panel.style.visibility = 'hidden';
                panel.style.overflow = 'hidden';
                panel.style.height = 'auto';
                panel.style.opacity = '1';
                const target = Math.max(panel.scrollHeight, 1);
                panel.style.height = '0px';
                panel.style.visibility = '';

                motion.set(panel, {
                    height: 0,
                    autoAlpha: 1,
                    overflow: 'hidden',
                });
                motion.to(panel, {
                    height: target,
                    duration: 0.36,
                    ease: 'power2.out',
                    overwrite: true,
                    onComplete: () => {
                        if (token !== this._animToken) return;
                        this._animating = false;
                        if (this.open) {
                            panel.style.height = 'auto';
                            panel.style.overflow = 'visible';
                        }
                    },
                });
            },
            refreshOpenHeight() {
                const panel = resolveEl(this.$refs.panelEl);
                if (!panel || !this.open) return;
                // 切换栏目时若未在开合动画中，直接跟随内容高度
                if (this._animating) return;
                panel.style.height = 'auto';
            },
            onUserItemClick(item) {
                if (!item) return;
                if (item.action === 'logout') {
                    this.$emit('logout');
                    return;
                }
                this.$emit('navigate', item.path || '/userCenter');
            },
        },
    };
</script>

<style lang="scss" scoped>
    .df-mega {
        /* 相对视口固定在页眉下方，避免 sticky 页滚动后 absolute 跟着文档上移 */
        position: fixed;
        top: 50px;
        left: 0;
        right: 0;
        z-index: 60;
        pointer-events: none;

        &.is-open {
            pointer-events: auto;
        }
    }

    .df-mega__panel {
        background: #ffffff;
        overflow: hidden;
        will-change: height, opacity;
        /* 参考理想汽车：按内容高度展开；预留足够高度展示两行车型，底部仍留遮罩可关闭 */
        max-height: min(680px, calc(100vh - 50px - 12vh));
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
    }

    .df-mega__inner {
        max-width: 1480px;
        margin: 0 auto;
        padding: 28px 40px 32px;
        max-height: min(680px, calc(100vh - 50px - 12vh));
        overflow-x: hidden;
        overflow-y: auto;
        overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.18);
            border-radius: 3px;
        }
    }

    .df-mega__section {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .df-mega__group-title {
        margin: 0 0 12px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        color: #666666;
    }

    .df-mega__cars {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 20px;
    }

    .df-mega-car {
        display: block;
        width: 240px;
        max-width: calc(25% - 15px);
        text-decoration: none;
        color: inherit;

        &:hover .df-mega-car__img {
            transform: translate(-50%, -54%) scale(1.08);
        }
    }

    .df-mega-car__body {
        position: relative;
        height: 220px;
        background: #f8f8f8;
        border-radius: 8px;
        overflow: hidden;
    }

    .df-mega-car__meta {
        position: absolute;
        top: 20px;
        left: 16px;
        right: 16px;
        z-index: 2;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .df-mega-car__name {
        font-size: 18px;
        font-weight: 600;
        line-height: 1.4;
        color: #1a1a1a;
    }

    .df-mega-car__desc {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 13px;
        line-height: 1.4;
        color: #666666;
    }

    .df-mega__category-tabs {
        display: flex;
        align-items: center;
        gap: 28px;
        border-bottom: 1px solid #eeeeee;
    }

    .df-mega__category-tab {
        position: relative;
        padding: 0 0 12px;
        border: 0;
        background: transparent;
        color: #666666;
        font-size: 16px;
        line-height: 1.4;
        cursor: pointer;

        &::after {
            position: absolute;
            right: 0;
            bottom: -1px;
            left: 0;
            height: 2px;
            background: #e60021;
            content: '';
            opacity: 0;
        }

        &.is-active {
            color: #1a1a1a;
            font-weight: 600;

            &::after {
                opacity: 1;
            }
        }
    }

    .df-mega-car__img {
        position: absolute;
        left: 50%;
        top: 52%;
        width: 72%;
        height: auto;
        transform: translate(-50%, -50%);
        object-fit: contain;
        pointer-events: none;
        transition: transform 0.25s ease;
    }

    .df-mega-car__price {
        position: absolute;
        right: 16px;
        bottom: 16px;
        z-index: 2;
        display: flex;
        align-items: baseline;
        gap: 3px;
    }

    .df-mega-car__price-num {
        font-size: 22px;
        font-weight: 600;
        line-height: 1;
        color: #1a1a1a;
    }

    .df-mega-car__price-unit {
        font-size: 12px;
        color: #666666;
    }

    .df-mega__cards {
        display: flex;
        flex-wrap: wrap;
        gap: 16px 20px;
    }

    .df-mega-card {
        position: relative;
        display: block;
        width: 240px;
        height: 160px;
        max-width: calc(25% - 15px);
        border-radius: 8px;
        overflow: hidden;
        text-decoration: none;
        color: #ffffff;
        transition: transform 0.25s ease, box-shadow 0.25s ease;

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
        }
    }

    .df-mega-card__bg {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .df-mega-card__title {
        position: relative;
        z-index: 1;
        display: block;
        padding: 20px 18px;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.4;
        text-shadow: 0 1px 8px rgba(0, 0, 0, 0.35);
    }

    .df-mega-card::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.28) 0%, transparent 50%);
        pointer-events: none;
    }

    @media (max-width: 1439px) {
        .df-mega__inner {
            padding: 24px 28px 28px;
        }

        .df-mega-car,
        .df-mega-card {
            width: 210px;
            max-width: calc(25% - 15px);
        }

        .df-mega-car__body {
            height: 200px;
        }

        .df-mega-card {
            height: 148px;
        }
    }

    @media (max-width: 1199px) {
        .df-mega-car,
        .df-mega-card {
            width: 200px;
            max-width: calc(33.33% - 14px);
        }

        .df-mega-car__body {
            height: 180px;
        }

        .df-mega-car__name,
        .df-mega-card__title {
            font-size: 16px;
        }

        .df-mega-card {
            height: 140px;
        }
    }
</style>
